module.exports = __webpack_public_path__ + "img/logo-head.c198be8a.png";